import { RecordView } from "web/components"

import SectionHeader from "./SectionHeader"
import { useLayouts } from "web/hooks/data"

export default function Section({
  subjectType,
  showToggle,
  isExpanded,
  data,
  onClick,
  ...rest
}) {
  const layouts = useLayouts({ subjectType })
  const summaryLayout = layouts.find((layout) => layout.name === "Summary")

  const fields = summaryLayout.fields.filter((f) => f.name !== "name")

  return (
    <div className="border-t border-neutral-8 first:border-t-0">
      {showToggle && (
        <SectionHeader subject={data} expanded={isExpanded} {...rest} />
      )}
      {isExpanded && (
        <div onClick={onClick}>
          <div className="p-2 text-sm">
            <RecordView data={data} fields={fields} fieldLimit={6} />
          </div>
        </div>
      )}
    </div>
  )
}
